<template>
  <div style="display: none;">
    <slot v-if="ready"></slot>
  </div>
</template>

<script>
import L from "leaflet";
import "./google-mutant";

import { findRealParent, propsBinder } from "vue2-leaflet";

const props = {
  options: {
    type: Object,
    default() {
      return {};
    }
  },
  apikey: {
    type: String,
    default() {
      return "";
    }
  },
  lang: {
    type: String,
    default: null
  },
  region: {
    type: String,
    default: null
  },
  name: {
    type: String,
    default: ""
  },
  layerType: {
    type: String,
    default: "base"
  },
  visible: {
    type: Boolean,
    default: true
  }
};

export default {
  props,
  data() {
    return {
      ready: false
    };
  },
  mounted() {
    this.mapObject = L.gridLayer.googleMutant(this.options);
    L.DomEvent.on(this.mapObject, this.$listeners);
    propsBinder(this, this.mapObject, props);

    this.ready = true;
    this.parentContainer = findRealParent(this.$parent);
    this.parentContainer.addLayer(this, !this.visible);
  },
  beforeDestroy() {
    try {
      if (this.parentContainer) {
        this.parentContainer.removeLayer(this);
      }

    } catch (e) {
      console.log("Error removing layer", e);
    }
  },
};
</script>
